import { ServicePage } from '@/components/ui/page-templates/ServicePage';

export function AssessmentConsultingPage() {
  const breadcrumbs = [
    { label: "Services", href: "/services" },
    { label: "Consulting", href: "/services/consulting" },
    { label: "Progress Assessment", href: "/services/consulting/assessment", current: true }
  ];

  return (
    <ServicePage
      title="Progress Assessment & Pricing"
      description="Periodic assessments on clients' progress and strategic pricing guidance to align goals with outcomes."
      breadcrumbs={breadcrumbs}
      category="Professional Services"
      accentColor="#1e293b"
    >
      <div className="prose dark:prose-invert max-w-none">
        <p>We provide structured progress assessments and pricing strategy support so you can track impact, communicate value, and optimize pricing for growth and sustainability.</p>
      </div>
    </ServicePage>
  );
}
